// ログイン画面（PF34 マジックリンク）。①メール送信 → ②メール内トークンを貼付 → 交換。
import { useState } from "preact/hooks";
import { isValidEmail } from "./session-core.mjs";
import {
  authBusySig,
  authErrorSig,
  magicSentSig,
  requestMagicLink,
  verifyToken,
} from "./session";

export function LoginView() {
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const busy = authBusySig.value;
  const err = authErrorSig.value;
  const sent = magicSentSig.value;

  return (
    <div class="ss-center">
      <div class="ss-login">
        <div class="ss-login-logo" />
        <h1 class="ss-login-title">SheetSnap にログイン</h1>

        {!sent ? (
          <>
            <p class="ss-login-lead">メールアドレスにログインリンクを送ります。</p>
            <input
              class="rt-input"
              type="email"
              inputMode="email"
              placeholder="you@example.com"
              value={email}
              onInput={(e) => setEmail((e.target as HTMLInputElement).value)}
              disabled={busy}
            />
            <button
              class="ss-login-btn"
              disabled={busy || !isValidEmail(email)}
              onClick={() => void requestMagicLink(email)}
            >
              {busy ? "送信中…" : "ログインリンクを送る"}
            </button>
          </>
        ) : (
          <>
            <p class="ss-login-lead">
              <strong>{email}</strong> にメールを送りました。メール内のトークンを貼り付けてください。
            </p>
            <input
              class="rt-input"
              type="text"
              placeholder="メールに記載のトークン"
              value={token}
              onInput={(e) => setToken((e.target as HTMLInputElement).value)}
              disabled={busy}
            />
            <button
              class="ss-login-btn"
              disabled={busy || token.trim().length === 0}
              onClick={() => void verifyToken(token)}
            >
              {busy ? "確認中…" : "ログイン"}
            </button>
            <button class="ss-login-link" disabled={busy} onClick={() => { magicSentSig.value = false; }}>
              メールアドレスを変更
            </button>
          </>
        )}

        {err && <div class="ss-login-err">{err}</div>}
      </div>
    </div>
  );
}
